import { css } from '@emotion/css'
import { getSkeletonColors } from '../../themes'

const styles = {
  icon: css({
    display: 'inline-flex',
    borderRadius: '50%',
    flex: '0 0 auto',
  }),
}

export default styles

export const iconTheme = theme =>
  css({
    backgroundColor: getSkeletonColors(theme),
  })

export const iconSize = size => {
  switch (size) {
    case 'extraSmall':
      return css({
        width: 16,
        height: 16,
      })

    case 'small':
      return css({
        width: 20,
        height: 20,
      })

    case 'medium':
      return css({
        width: 30,
        height: 30,
      })

    default:
      return css({
        width: 24,
        height: 24,
      })
  }
}
